import * as React from "react";
import { FinesView } from "@tlc/ls2pac/app/views/myAccountViews/accountActivitySubViews/FinesView";
import { useAccount } from "../../Account";

export const AccountFinesPage: React.FC = () => {
  const { accountSummary, user, patron } = useAccount();
  const viewRef = React.useRef<FinesView | null>(null);
  const [isViewReady, setIsViewReady] = React.useState(false);
  const containerId = "finesContainer";

  React.useEffect(() => {
    viewRef.current = new FinesView();
    setIsViewReady(true);
    return () => {
      if (viewRef.current) {
        viewRef.current.cleanup();
      } else {
        console.warn("Tried to call FinesView cleanup, but view is null");
      }
    };
  }, []);

  React.useEffect(() => {
    if (isViewReady && viewRef.current) {
      viewRef.current.load(
        { accountSummary, patron },
        user,
        document.getElementById(containerId),
        "fines"
      );
    }
  }, [accountSummary, user, patron, isViewReady]);

  return <div id="finesContainer"></div>;
};
